import { render, staticRenderFns } from "./showcase.vue?vue&type=template&id=b19a2888&scoped=true"
import script from "./showcase.vue?vue&type=script&lang=js"
export * from "./showcase.vue?vue&type=script&lang=js"
import style0 from "./showcase.vue?vue&type=style&index=0&id=b19a2888&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19a2888",
  null
  
)

export default component.exports